<template>
  <b-col class="mb-3 pr-0" xl="3" md="4" sm="6">
    <select-button
      :active="isActive"
      :icon="icon"
      :label="label"
      @click="click"
    ></select-button>
  </b-col>
</template>

<script>
import SelectButton from "./SelectButton";

export default {
  name: "ScheduleSelectButton",

  components: { SelectButton },

  props: {
    item: {
      type: Object,
      default: () => null
    },
    isActive: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    }
  },
  
  methods: {
    click() {
      this.$emit("onClick", this.item);
    }
  }
};
</script>
